import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { api } from './api';
import { getNewStateByAttr, getNewStateById } from './entities';
const initialState = {
    byEventGameId: {},
    byId: {},
    status: 'init'
};
export const fetchBets = createAsyncThunk('bets/fetch', async (eventGameId, thunkApi) => {
    try {
        return await (await api.instance).fetchBets({ eventGameId });
    }
    catch (error) {
        return thunkApi.rejectWithValue(error);
    }
});
const betsSlice = createSlice({
    name: 'bets',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchBets.fulfilled, (state, action) => {
            state.byId = getNewStateById(state.byId, action.payload);
            state.byEventGameId = getNewStateByAttr(state.byId, 'eventGameId');
            state.status = 'success';
        })
            .addCase(fetchBets.pending, (state) => {
            state.status = 'fetching';
        })
            .addCase(fetchBets.rejected, (state) => {
            state.status = 'error';
        });
    }
});
export const betsReducer = betsSlice.reducer;
